<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'PoC v2')
</script>

<template>
  <q-page padding class="page"> </q-page>
</template>
